export const replaceWhiteSpaces = (str) => {
  return str.trim().replace(/\s+/g, "-");
};

export const isFeatureEnabled = (features, featureName) =>
  features.some((feature) => feature?.name?.toLowerCase() === featureName);
